import {createStyles, Theme} from "@material-ui/core";

export const ImportCalendarStyle = (theme: Theme) => createStyles({
    accountItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      minWidth: 'calc(50% - 24px)',
      cursor: 'pointer',
    },}
  );



// WEBPACK FOOTER //
// ./src/components/calendar-export/import.calendar.style.ts